export class BookedNotWorkedModel {
  _id: string;
  charged: number;
}
